import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelListComponent } from './modellist/modellist.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule} from '@angular/material/tabs';
import { ModelDetailComponent } from './model-detail/model-detail.component';
import { RouterModule } from '@angular/router';
import { ModelDetailFormComponent } from './model-detail-form/model-detail-form.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SkeletonModule } from '../shared/skeleton/skeleton.module';
import { ModelImageFullscreenViewModule } from './model-image-fullscreen-view/model-image-fullscreen-view.module';
import { ModelOnboardingChecklistComponent } from './model-onboarding-checklist/model-onboarding-checklist.component';


@NgModule({
  declarations: [
    ModelListComponent,
    ModelDetailComponent,
    ModelDetailFormComponent,
    ModelOnboardingChecklistComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    FlexModule,
    MatIconModule,
    MatSnackBarModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    RouterModule,
    MatTabsModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  SkeletonModule,
  ModelImageFullscreenViewModule
  ],
  exports: [
    ModelDetailFormComponent,
    ModelOnboardingChecklistComponent
  ]
})
export class ModelModule { 
}
